import { inject } from '@angular/core';
import { CanDeactivateFn, Router } from '@angular/router';
import { DettaglioMessaggioComponent } from '../app/shared/components/dettaglio-messaggio/dettaglio-messaggio.component';

export const pendingExitGuard: CanDeactivateFn<DettaglioMessaggioComponent> = component => {
  if (inject(Router).getCurrentNavigation()?.trigger === 'popstate') return true;
  return component.canLeave();
};